import React from 'react';
import { Container, Card, CardImg, CardTitle, Modal, Button, Breadcrumb, BreadcrumbItem, CardFooter } from 'reactstrap';
import { Col, Row } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';

const json = [
  {
    imgUrl: 'https://image.freepik.com/free-vector/female-student-passing-exam-checking-answers_74855-14022.jpg',
    title: 'Test 1',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/female-student-passing-exam-checking-answers_74855-14022.jpg',
    title: 'Test 2',
  },
  {
    imgUrl: 'https://image.freepik.com/free-vector/female-student-passing-exam-checking-answers_74855-14022.jpg',
    title: 'Test 3',
  },
];

export default function UnitTest() {
  const history = useHistory();

  const params = useParams();

  const { classId } = params;

  const [state, setState] = React.useState({
    exampleModal: false,
  });

  const toogleModal = React.useCallback(
    () => () => {
      setState((prevState) => ({ ...prevState, exampleModal: !prevState.exampleModal }));
    },
    [setState],
  );

  const renderList = React.useMemo(() => {
    return json.map((item, index) => {
      return (
        <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={6} key={index} className='mt-2'>
          <Card key={index} style={{ cursor: 'pointer' }} onClick={toogleModal()}>
            <CardImg alt='...' src={item.imgUrl} top />
            <CardFooter>
              <CardTitle style={{ fontWeight: 600, fontSize: 20 }}>{item.title}</CardTitle>
            </CardFooter>
          </Card>
        </Col>
      );
    });
  }, [toogleModal]);

  const renderModal = React.useCallback(() => {
    return (
      <>
        <div className='modal-header'>
          <button aria-label='Close' className='close' data-dismiss='modal' type='button' onClick={toogleModal()}>
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className='modal-body d-flex justify-content-center'>
          <img style={{ width: '100%' }} alt='' src='https://image.freepik.com/free-vector/coming-soon-promotion-banner-coming-soon_100456-985.jpg' />
        </div>
        <div className='modal-footer'>
          <Button color='secondary' data-dismiss='modal' type='button' onClick={toogleModal()}>
            Close
          </Button>
        </div>
      </>
    );
  }, [toogleModal]);

  return (
    <>
      <div className='header bg-info pb-6'>
        <Container fluid>
          <div className='header-body'>
            <Row className='align-items-center py-4'>
              <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <h6 className='h2 text-white d-inline-block mb-0'>
                  <span style={{ cursor: 'pointer' }} onClick={() => history.push('/lms/sampleTests')}>
                    Sample Test
                  </span>
                </h6>{' '}
                <Breadcrumb className='d-none d-md-inline-block ml-md-4' listClassName='breadcrumb-links breadcrumb-dark'>
                  <BreadcrumbItem>
                    <Link style={{ cursor: 'pointer' }} to={`/lms/sampleTest/${classId}/Units`}>
                      Unit
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem aria-current='page' className='active'>
                    <Link style={{ fontSize: 15 }}>Tests</Link>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container fluid className='mt--6'>
        <Row gutter={[16, 0]}>{renderList}</Row>
        <Modal className='modal-dialog-centered modal-lg' isOpen={state.exampleModal} toggle={toogleModal()}>
          {renderModal()}
        </Modal>
      </Container>
    </>
  );
}
